import React from 'react';

export default function SomethingWentWrongSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78">
      <g fill="none" fillRule="nonzero" transform="translate(-2 -2)">
        <rect width="36" height="78" x="22.649" y="1.647" fill="#7992A5" rx="4" transform="rotate(135 40.649 40.647)" />
        <rect width="36" height="78" x="22.648" y="1.648" fill="#FDB5B4" rx="4" transform="rotate(45 40.648 40.648)" />
        <rect
          width="26"
          height="26"
          x="27.648"
          y="27.648"
          fill="#F1726B"
          opacity=".5"
          rx="2"
          transform="rotate(45 40.648 40.648)"
        />
        <path
          fill="#F1726B"
          d="M61.862 32.163a2 2 0 1 1-2.829 2.828 2 2 0 0 1 2.829-2.828zm7.07-7.07a2 2 0 1 1-2.828 2.827 2 2 0 0 1 2.829-2.828zm-9.9-2.83a2 2 0 1 1-2.828 2.83 2 2 0 0 1 2.829-2.83zm-9.898-2.828a2 2 0 1 1-2.829 2.828 2 2 0 0 1 2.829-2.828zm7.07-7.071a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.829-2.828zm-28.283 53.74a2 2 0 1 1-2.829 2.828 2 2 0 0 1 2.829-2.828zm7.07-7.07a2 2 0 1 1-2.828 2.827 2 2 0 0 1 2.829-2.828zm-9.9-2.83a2 2 0 1 1-2.828 2.83 2 2 0 0 1 2.829-2.83zm-9.898-2.828a2 2 0 1 1-2.829 2.828 2 2 0 0 1 2.829-2.828zm7.07-7.071a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.829-2.828z"
        />
        <path fill="#2B5672" d="M42.769 68.225l-2.121-2.121 25.456-25.456z" />
      </g>
    </svg>
  );
}

SomethingWentWrongSvg.displayName = 'SomethingWentWrongSvg';
